import { EntityState } from '@ngrx/entity';
import { Contact } from './models/contact.model';
import { externalContactAdapter } from './adapters/external-contact.adapter';

export type GenesysCloudExternalContactsState = EntityState<Contact>;

export const initialState = (): GenesysCloudExternalContactsState => externalContactAdapter.getInitialState();
